import './CoralBannerCTA.scss'

import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CTA } from '@websrc/App/Components/CTA'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapCoralWebBannerCta } from '@websrc/DataMappers/mapArticleBody'
import React, { useEffect, useRef, useState } from 'react'

type CoralBannerCTAProps = ReturnType<typeof mapCoralWebBannerCta>

export const CoralBannerCTA = ({
  header,
  description,
  asset,
  button,
  visualsColors,
}: CoralBannerCTAProps) => {
  const handleCardClick = () => {
    matomo.trackEvent(
      'engagement',
      'Coral Blog Article',
      ['Banner CTA Clicked'],
      [header],
      'button'
    )

    if (ctaRef.current) {
      ctaRef.current.click()
    }
  }
  const contentRef = useRef<HTMLDivElement>(null)
  const ctaRef = useRef<any>(null)
  const [contentHeight, setContentHeight] = useState<number | null>(null)

  useEffect(() => {
    const node = contentRef.current
    if (!node) return

    const observer = new ResizeObserver(() => {
      setContentHeight(node.getBoundingClientRect().height)
    })

    observer.observe(node)

    return () => observer.disconnect()
  }, [])
  return (
    <div className={'blog-article-banner-cta'} onClick={handleCardClick}>
      <div
        className={'blog-article-banner-cta__frame-image'}
        style={{ height: contentHeight ?? 'auto' }}
      >
        <Asset
          altText={'Placeholder Image'}
          className={'blog-article-banner-cta__image'}
          lazyLoading={true}
          objectFit={'cover'}
          srcSetWidths={[400, 600, 800, 1200, 1600]}
          thumbnail={asset?.thumbnail}
          video={asset?.video}
        />
      </div>
      <div
        className={`blog-article-banner-cta__content m--visual-${visualsColors}`}
        ref={contentRef}
      >
        <div className={'blog-article-banner-cta__header'}>{header}</div>
        <div className={'blog-article-banner-cta__description'}>{description}</div>
        <div className={'blog-article-banner-cta__button'}>
          <CTA
            className={'coral-global-button m--type-fill m--theme-white m--size-md'}
            cta={button}
            ref={ctaRef}
            type={'clean'}
          />
        </div>
      </div>
    </div>
  )
}
